var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSailboat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000057114075915648005020000000546455954690022021_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 868 831",
    style: {
      enableBackground: "new 0 0 868 831"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#434242;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M752,829l-545,2C92.7,831,0,784.4,0,727l0,0h868L752,829z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.9,686.1L43.7,713l0,0c80.4-233,203.4-448.9,362.8-636.9L471,0l-16.3,94 c-30.4,174.8-15.9,354.5,41.9,522.2L530,713L389,686.6C323.6,674.3,256.4,674.1,190.9,686.1L190.9,686.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M541,715l0.2-0.4l0,0c-42-165.4-72.2-285.1-78.3-426.4c-1.8-41.1-0.7-82.3,2.7-123.3l7.7-91.8l27.6,75.4 c51.3,140.3,125.2,274,215,388.8L831,679l0,0C784.8,657.9,578.9,681.1,541,715C540.2,715.7,541.8,714.2,541,715L541,715z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSailboat);
export default __webpack_public_path__ + "static/media/sailboat.6ab482e1b9ef773983a77b997f444a5c.svg";
export { ForwardRef as ReactComponent };